export const PREDICTOR_NAMES: Record<number, string> = {
  0: "ctr",
  1: "cpc",
  2: "recommender",
  3: "cpm",
  5: "buying_price",
  6: "max_bid",
  7: "imp_val",
  8: "budget_dist",
  9: "ecpx_filter",
  10: "longterm",
  11: "campaign_cpc",
  12: "historical",
  13: "risk_aversion",
  14: "sliding",
  15: "daily_metrics",
  16: "weekly_metrics",
  17: "monthly_metrics",
  18: "feature_flags",
  19: "hourly_metrics",
  20: "ad_selector",
  21: "auto_spend",
  22: "auto_performance",
  23: "traffic_exclusion",
  24: "user_event",
  25: "campaign_selection",
  26: "install",
  27: "audience_similarity",
  28: "spend_adjustment",
  29: "skan_settings",
  30: "ctr_two_tower",
  31: "ua_bidding_strategy",
  32: "action",
  33: "win_price",
  34: "publisher_blocklist",
  35: "tree_based_install",
};

export function predictorTypeName(value: number): string {
  return PREDICTOR_NAMES[value] ?? `predictor_${value}`;
}
